import SharedSelectProject, {
    SelectedProjectType,
} from '../src/components/ContactModal/SharedSelectProject';

export type { SelectedProjectType };
export default SharedSelectProject;
